import { useWeb3React } from '@web3-react/core'
import { useIncentiveQuery } from 'graphql/thegraph/incentives'

import { Incentive } from '../types/incentives'

/**
 * Returns the incentive configuration for a given incentive ID
 * @param id The incentive ID to find
 * @returns The incentive configuration or undefined if not found
 */
export function useIncentiveConfig(id: string | undefined): Incentive | undefined {
  const { chainId } = useWeb3React()

  // Use our query hook to directly fetch the incentive by ID
  const { data: incentive } = useIncentiveQuery(id || null)

  // If chainId is not available, return undefined
  if (!chainId) return undefined

  // Otherwise, return the incentive directly
  return incentive
}
